import PropTypes from 'prop-types';
import React from 'react';

const PaymentErrors = ({ message }) => {
  return (
    <>
      <div className="error-message">{message}</div>
      <style jsx>{`
        .error-message {
          display: block;
          border: 1px solid #eb3f3c;
          background: #fae6e8;
          color: #eb3f3c;
          margin: 6px 0px;
          line-height: 2em;
          padding: 3px 12px;
        }
      `}</style>
    </>
  );
};

PaymentErrors.propTypes = {
  message: PropTypes.string,
};

export default PaymentErrors;
